export default __webpack_public_path__ + "static/media/upiLogo.0e23a817.png";